const VARIANT_TYPES = {
  WITH_IMAGE: 'withimage',
  WITHOUT_IMAGE: 'withoutimage',
  DROPDOWN_WITH_IMAGE: 'dropdown-withimage',
  DROPDOWN_WITHOUT_IMAGE: 'dropdown-withoutimage',
};

const VARIANT_SHAPE = {
  SQUARE: 'square',
  RECTANGLE: 'rectangle'
};

const MOBILE_VARIANT_SHAPE_IMAGE_PROPS = {
  [VARIANT_TYPES.WITH_IMAGE]: {
    [VARIANT_SHAPE.SQUARE]: {
      width: '72',
      height: '54'
    },
    [VARIANT_SHAPE.RECTANGLE]: {
      width: '54',
      height: '72'
    }
  },
  [VARIANT_TYPES.DROPDOWN_WITH_IMAGE]: {
    [VARIANT_SHAPE.SQUARE]: {
      width: '64',
      height: '64'
    },
    [VARIANT_SHAPE.RECTANGLE]: {
      width: '64',
      height: '64'
    }
  }
}

const MOBILE_VARIANT_TYPE_PROPS = {
  [VARIANT_TYPES.WITH_IMAGE]: {
    isShowImage: true,
    isDropdown: false
  },
  [VARIANT_TYPES.DROPDOWN_WITH_IMAGE]: {
    isShowImage: true,
    isDropdown: true
  },
  [VARIANT_TYPES.WITHOUT_IMAGE]: {
    isShowImage: false,
    isDropdown: false
  },
  [VARIANT_TYPES.DROPDOWN_WITHOUT_IMAGE]: {
    isShowImage: false,
    isDropdown: true
  },
}

const DESKTOP_VARIANT_SHAPE_IMAGE_PROPS = {
  [VARIANT_TYPES.WITH_IMAGE]: {
    [VARIANT_SHAPE.SQUARE]: {
      width: '54',
      height: '54'
    },
    [VARIANT_SHAPE.RECTANGLE]: {
      width: '46',
      height: '62'
    }
  },
  [VARIANT_TYPES.DROPDOWN_WITH_IMAGE]: {
    [VARIANT_SHAPE.SQUARE]: {
      width: '64',
      height: '64'
    },
    [VARIANT_SHAPE.RECTANGLE]: {
      width: '64',
      height: '64'
    }
  }
}

const DESKTOP_VARIANT_TYPE_PROPS = {
  [VARIANT_TYPES.WITH_IMAGE]: {
    isShowImage: true,
    isDropdown: false
  },
  [VARIANT_TYPES.DROPDOWN_WITH_IMAGE]: {
    isShowImage: true,
    isDropdown: true
  },
  [VARIANT_TYPES.WITHOUT_IMAGE]: {
    isShowImage: false,
    isDropdown: false
  },
  [VARIANT_TYPES.DROPDOWN_WITHOUT_IMAGE]: {
    isShowImage: false,
    isDropdown: true
  },
}

export {
  VARIANT_TYPES,
  VARIANT_SHAPE,
  DESKTOP_VARIANT_SHAPE_IMAGE_PROPS,
  DESKTOP_VARIANT_TYPE_PROPS,
  MOBILE_VARIANT_SHAPE_IMAGE_PROPS,
  MOBILE_VARIANT_TYPE_PROPS
};
